var _circle, _circle2, _circle3, _path, _circle4, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCirclesBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 2100,
    viewBox: "0 0 1440 1570",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1539,
    cy: 400,
    r: 399,
    stroke: "#C0E6F2",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1538.34,
    cy: 399.339,
    r: 289.909,
    stroke: "#C0E6F2",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: -86,
    cy: 1345,
    r: 224,
    stroke: "#C0E6F2",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.2648 1344.63C76.2648 1434.45 3.45007 1507.26 -86.3715 1507.26C-176.193 1507.26 -249.008 1434.45 -249.008 1344.63C-249.008 1254.81 -176.193 1181.99 -86.3715 1181.99C3.45007 1181.99 76.2648 1254.81 76.2648 1344.63Z",
    stroke: "#C0E6F2",
    strokeWidth: 2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: -86,
    cy: 1345,
    r: 224,
    stroke: "#C0E6F2",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2648 1344.63C76.2648 1434.45 3.45007 1507.26 -86.3715 1507.26C-176.193 1507.26 -249.008 1434.45 -249.008 1344.63C-249.008 1254.81 -176.193 1181.99 -86.3715 1181.99C3.45007 1181.99 76.2648 1254.81 76.2648 1344.63Z",
    stroke: "#C0E6F2",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirclesBackground);
export default __webpack_public_path__ + "static/media/circles_background.612d9c5bf32ca9946a28832a57fa8ae6.svg";
export { ForwardRef as ReactComponent };